import type { Collection } from '@/types/collection';
import type { CategoryHeader } from '@/utils/pages/api';

/**
 * Gets primary heading for music/SFX category pages
 * Uses primary_heading for authenticated users, primary_heading_visitor for visitors
 * Falls back to page name if no primary headings are set
 */
export const getPrimaryHeading = ({
  data,
  userIsAuthenticated
}: {
  data: CategoryHeader | Collection;
  userIsAuthenticated: boolean;
}) => {
  const {
    primary_heading,
    primary_heading_visitor,
    name
  } = data;
  if (userIsAuthenticated) {
    return primary_heading ?? primary_heading_visitor ?? name;
  }
  return primary_heading_visitor ?? primary_heading ?? name;
};